import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BasicFilters } from '../model/filters/basic-filters';
import { Observable } from 'rxjs';
import { HttpUtils } from '../shared/http.utils';
import { TenantsResponse } from '../model/responses/tenants-response';
import { TenantPersistRequest } from '../model/requests/tenant-persist-request';

@Injectable({
  providedIn: 'root'
})
export class ApiKeysService {

  private readonly tenantsURL: string;

  constructor(private http: HttpClient) {
    this.tenantsURL = '/catalog/apikeys/tenant';
  }

  public getTenantApiKey(tenantUuid: string) {
    const url = `${this.tenantsURL}/${tenantUuid}/apikey`;
    return this.http.get<any>(url);
  }

  public getNewTenantApiKey(tenantUuid: string) {
    const url = `${this.tenantsURL}/${tenantUuid}/newapikey`;
    return this.http.get<any>(url);
  }

  public getOrganizationApiKey(tenantUuid: string, organizationUuid: string) {
    const url = `${this.tenantsURL}/${tenantUuid}/organization/${organizationUuid}/apikey`;
    return this.http.get<any>(url);
  }

  public getNewOrganizationApiKey(tenantUuid: string, organizationUuid: string) {
    const url = `${this.tenantsURL}/${tenantUuid}/organization/${organizationUuid}/newapikey`;
    return this.http.get<any>(url);
  }

}
